<!-- Container-fluid starts-->
<div class="container-fluid pb-3 pt-5  justify-content-center">
  <div class="email-wrap bookmark-wrap">
    <div class="row ">

      <div class="col-xl-9 col-md-12 box-col-12">
        <div class="email-right-aside bookmark-tabcontent contacts-tabs">
          <div class="card mb-0 pl-5 pt-5" id="section">
            <div class="card-body p-5 pt-5 align-items-center">
              <div class="row list-persons" id="addcon">
                <div class="col-xl-4 xl-50 col-md mt-5" *ngFor="let row of user_data ">

                  <img class="img-responsive img-thumbnail " src="{{url}}/{{row.qr_code}}" />
                  <div class="row" *ngIf="role=='Security'">
                    <div style="padding-top: 70px;" *ngIf="row.approval_status=='approved'">
                      <button class="btn btn-primary" type="button" style="width: 110px; height: 30px;"
                        (click)="openXl(content)" placement="top" ngbTooltip="capture">Capture</button>&nbsp;
                      <button class="btn btn-warning" type="button" placement="top" style=" width: 100px; height: 30px;"
                        ngbTooltip="reset" printSectionId="section" [useExistingCss]="true" ngxPrint>Print</button>
                    </div>
                  </div>
                </div>
                <div class="col-xl-8 xl-50 col-md-7" *ngFor="let row of user_data ">
                  <div class="tab-content" id="v-pills-tabContent">

                    <div class="tab-pane contact-tab-0 tab-content-child fade show active" id="v-pills-user"
                      role="tabpanel" aria-labelledby="v-pills-user-tab">
                      <div class="profile-mail">
                        <div class="media">
                          <div *ngIf="status==1">
                            <img *ngIf="row.visitor_image!=null"
                            class="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                            [src]="imageUrl" alt="">
                            
                          </div>
                          <div *ngIf="status!=1">
                            <img *ngIf="row.visitor_image!=null"
                            class="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                            src="{{url}}/{{row.visitor_image}}" alt="">
                            
                          </div>
                          <img *ngIf="row.visitor_image==null"
                            class="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                            src="data:image/png;base64,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"
                            alt="">
                          <!-- <input class="updateimg" type="file" name="img"> -->
                          <div class="media-body mt-0" *ngFor="let row of user_data ">
                            <h5><span class="first_name_0 font-primary">{{row.visitor}} </span><span
                                class="last_name_0"></span>
                            </h5>
                            <!-- <p class="font-primary"class="email_add_0">{{row.email||empty}}</p> -->

                          </div>
                        </div>
                        <div class="email-general">
                          <h3 class="">Visitor Information</h3>
                          <div class="container">
                            <div class="row" *ngFor="let row of user_data ">
                              <div class="col-md col-sm">
                                <label class="">Address</label>
                                <h4 class="font-primary">{{row.address||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Mobile Number</label>
                                <h4 class="font-primary">{{row.contact_number||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Email</label>
                                <h4 class="font-primary">{{row.email||empty}}</h4>
                              </div>
                            </div>

                            <div class="row " *ngFor="let row of user_data ">

                              <div class="col-md col-sm">
                                <label class="">Visitor Type</label>
                                <h4 class="font-primary">{{row.visitor_role||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Approval Status</label>
                                <h4 class="font-primary">{{row.approval_status||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Approval Status</label>
                                <h4 class="font-primary">{{row.entry_status||empty}}</h4>
                              </div>
                            </div>
                            <div class="row " *ngFor="let row of user_data ">
                              <div class="col-md col-sm">
                                <label class="">Approved By</label>
                                <h4 class="font-primary">{{row.approved_by||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Approval Time</label>
                                <h4 class="font-primary">{{row.approved_time||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Created</label>
                                <h4 class="font-primary">{{row.created||empty}}</h4>
                              </div>
                            </div>

                            <div class="row " *ngFor="let row of user_data ">
                              <div class="col-md col-sm">
                                <label class="">Reason</label>
                                <h4 class="font-primary">{{row.reason||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Checkin</label>
                                <h4 class="font-primary">{{row.time_in||empty}}</h4>
                              </div>
                              <div class="col-md col-sm">
                                <label class="">Checkout</label>
                                <h4 class="font-primary">{{row.time_out||empty}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #content let-modal>
  <!-- <div class="modal-header">
   
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div> -->
  <div class="modal-body justify-content center">
    <div class="">
      <button type="button" class="close" (click)="modal.close('Close click')" aria-label="Close">×</button> 
   
    </div>
  
    <div *ngIf="hide" class="pl-5">
      <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></webcam>

    </div>
    <div *ngIf="!hide" class="pl-5">
      <img [src]="webcamImage" />

    </div>

  </div>
  <div class="modal-footer">
    <button *ngIf="!hide" type="button" class="btn btn-outline-dark" (click)="retakePicture()">Retake</button>
    <button *ngIf="!hide" type="button" class="btn btn-outline-dark" (click)="saveImage(webcamImage)"  (click)="modal.close('Close click')">save</button>
    <button *ngIf="hide" type="button" class="btn btn-outline-dark" (click)="takePicture()" >Take Picture</button>
  </div>
</ng-template>


<!-- Container-fluid Ends-->